import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { CoreModule } from './core/core.module';
import { FormsModule } from '@angular/forms';

import { ShellModule } from './shell/shell.module';

import { LOCALE_ID } from '@angular/core';

import { LogInComponent } from './log-in.component';
import { WorkplaceComponent } from './workplace.component';

import { WORKPLACE_ROUTES } from './workplace.routes';

declare var accessMatrix: IAccessMatrix;

@NgModule({
    imports: [
		BrowserModule,
	    HttpClientModule,
	    FormsModule,
        CoreModule.forRoot(window['appConfig'].environment),
       
        RouterModule.forRoot(WORKPLACE_ROUTES),
        ShellModule
    ],
    declarations: [WorkplaceComponent, LogInComponent],
    providers: [
 
		{ provide: LOCALE_ID, useValue: "sv-SE" } //TODO: Load this dynamically from some settings service
	], 
    bootstrap: [WorkplaceComponent]
})
export class WorkplaceModule {}

interface IAccessMatrix {
    modules: { [index:string]: boolean }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/workplace.module.ts